import * as React from "react";
import { CSSTransition } from "react-transition-group";
import SwipeableViews from "react-swipeable-views";
import {
  Grid,
  Typography,
  Input,
  IconButton,
  Button,
  withStyles,
  FormControl,
  Snackbar,
} from "@material-ui/core";
import { Close, ArrowBack } from "@material-ui/icons";
import { observer } from "mobx-react";
import { RateLibraryStore } from "modules/rateLibrary/RateLibraryStore";
import { RateLibraryService } from "modules/rateLibrary/RateLibraryService";
import i18n from "i18n";
import * as _ from "lodash";
import * as libLocations from "modules/rateLibrary/assets/rateLibraryLocation";
import imgImport from "modules/rateLibrary/assets/import-rate-lib.svg";
import ReactSelect from "common/components/ReactSelect";

const styles = (theme) => ({
  container: {
    left: 0,
    top: 67,
    zIndex: 3,
    height: "calc(100vh - 67px)",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    "& > :last-child": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  header: {
    backgroundColor: theme.palette.secondary.light,
    borderBottom: "1px solid #f2f2f2",
    height: "60px",
  },
  title: {
    lineHeight: "60px",
    fontSize: "16px",
    fontFamily: "Raleway",
    display: "inline-block",
    cursor: "pointer",
  },
  newProject: {
    left: "100%",
    top: 0,
    cursor: "auto",
  },
  closeLayerIcon: {
    right: 20,
    top: 80,
  },
  backLayerIcon: {
    left: 20,
    top: 20,
  },
  layerTitleContainer: {
    marginTop: 80,
  },
  layerSecondTitleContainer: {
    marginTop: 36,
  },
  layerSecondTitleMessage: {
    fontSize: "26px",
    fontFamily: "Raleway",
    fontWeight: 400,
    marginTop: 30,
  },
  layerTitle: {
    fontSize: "12px",
    fontFamily: "Raleway",
    fontWeight: 400,
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "520px",
    margin: "0 auto",
    marginTop: "30px",
    marginBottom: "70px",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  transitionEnter: {
    opacity: 0.01,
  },
  transitionEnterActive: {
    opacity: 1,
    transition: "opacity 300ms ease-in",
  },
  transitionLeave: {
    opacity: 1,
  },
  transitionLeaveActive: {
    opacity: 0.01,
    transition: "opacity 300ms ease-in",
  },
  chips: {
    display: "flex" as any,
    flexWrap: "wrap" as any,
    justifyContent: "center" as any,
  },
  chip: {
    margin: "1px 5px",
  },
  soon: {
    position: "relative" as any,
    top: "40%",
    color: "rgba(0, 0, 0, 0.34)",
    margin: "0px auto",
    width: 105,
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.34)",
    borderWidth: 1,
    borderRadius: 50,
    height: 21,
    paddingTop: 4,
    fontSize: 10,
  },
  createBlank: {
    position: "relative" as any,
    top: 163.5,
    color: "rgba(0, 0, 0, 0.34)",
    margin: "0px auto",
    width: 130,
    fontSize: "16px",
    fontFamily: "Raleway",
    fontWeight: 500,
  },
  cardImport: {
    backgroundColor: "white",
    transition: "box-shadow 300ms ease-in",
    width: 230,
    height: 230,
    margin: "30px 15px",
    float: "left" as any,
    "&:hover": {
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    },
  },
  import: {
    width: "100%",
    paddingTop: 25,
    height: 70,
    textAlign: "center" as any,
    fontSize: "16px",
    fontFamily: "Roboto",
    fontWeight: 500,
  },
});

type IProps = {
  classes: any;
};

/* function getLocationLabel(value) {
  let location = _.find(libLocations.availableLocations, function (o) { return o.value == value; });
  let state = location != undefined ? location.label : '';
  return state;
} */

@observer
class LayerAddRateLibrary extends React.Component<IProps> {
  state = {
    name: "",
    description: "",
    disabled: false,
    location: Array(),
    share: Array(),
    index: 0,
    snack: false,
  };

  handleSnack = () => {
    this.setState({ snack: true });
  };

  handleSnackClose = () => {
    this.setState({ snack: false });
  };

  handleInputChangeEvent = (e, type) => {
    if (type === "name") this.setState({ name: e.target.value });
    if (type === "description") this.setState({ description: e.target.value });
  };

  handleNext = () => {
    //RateLibraryService.AddRateLibrary(this.state.name);
    this.setState({ index: 1 });
    //RateLibraryStore.layerAdd = false;
  };

  handleBack = () => {
    //RateLibraryService.AddRateLibrary(this.state.name);
    this.setState({ index: 0 });
    //RateLibraryStore.layerAdd = false;
  };

  handleChange = (event) => {
    this.setState({ location: event });
  };

  handleCloseLayerAdd = () => {
    RateLibraryStore.layerAdd = false;
    this.setState({
      index: 0,
      location: new Array(),
      name: "",
      disabled: false,
    });
  };

  handleChangeIndex = (index) => {
    this.setState({ value: index });
  };

  async fileChangedHandler(event) {
    let file = event.target.files[0];
    if (file.name.includes("xlsx") || file.name.includes("xls")) {
      for (let j = 0; j < this.state.location.length; j++) {
        for (let i = 0; i < libLocations.availableLocations.length; i++) {
          if (
            this.state.location[j].label ===
            libLocations.availableLocations[i].label
          ) {
            this.state.location[j].value =
              libLocations.availableLocations[i].value;
          }
        }
      }

      RateLibraryService.AddLibrary(
        file,
        this.state.name,
        this.state.description,
        this.state.location.map((loc) => loc.value),
        this.state.share.map((sha) => sha.value)
      );
      this.handleCloseLayerAdd();
    } else {
      this.setState({ snack: true });
    }
  }

  render() {
    const { classes } = this.props;
    //this.state.location)
    return (
      <CSSTransition
        in={RateLibraryStore.layerAdd}
        enter={true}
        exit={true}
        timeout={300}
        classNames={{
          enter: classes.transitionEnter,
          enterActive: classes.transitionEnterActive,
          exit: classes.transitionLeave,
          exitActive: classes.transitionLeaveActive,
        }}
        unmountOnExit
      >
        <Grid
          container
          className={classes.container}
          style={{ position: "absolute" }}
        >
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            open={this.state.snack}
            autoHideDuration={6000}
            onClose={this.handleSnackClose}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
            message={
              <span id="message-id">
                {i18n.rateLibraries.layerAdd.supportFileType}
              </span>
            }
            action={[
              <IconButton color="inherit" onClick={this.handleSnackClose}>
                <Close />
              </IconButton>,
            ]}
          />
          <Grid container item xs={12} className={classes.header}>
            <Grid item xs={2} style={{ textAlign: "center" }}>
              <Typography
                className={classes.title}
                style={{ textAlign: "center", position: "relative" }}
                onClick={this.handleCloseLayerAdd}
              >
                {i18n.menu.rateLibrary}
                <span
                  className={classes.newProject}
                  style={{ position: "absolute", whiteSpace: "nowrap" }}
                >
                  &ensp;{">"}&ensp;
                  <span style={{ fontWeight: 700 }}>
                    {i18n.rateLibraries.layerAdd.new}
                  </span>
                </span>
              </Typography>
            </Grid>
          </Grid>

          <IconButton
            onClick={this.handleCloseLayerAdd}
            className={classes.closeLayerIcon}
            style={{ position: "absolute", zIndex: 2 }}
          >
            <Close fontSize="small" />
          </IconButton>
          <SwipeableViews
            index={this.state.index}
            disabled={true}
            onChangeIndex={this.handleChangeIndex}
            style={{
              height: "calc(100vh - (64px + 64px))",
              overflow: "hidden",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <div className={classes.layerTitleContainer}>
                <Typography className={classes.layerTitle} component="h2">
                  {i18n.rateLibraries.layerAdd.title}
                </Typography>
              </div>
              <Input
                autoFocus
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: "30",
                }}
                className={classes.input}
                placeholder={i18n.rateLibraries.layerAdd.namePlaceholder}
                onChange={(e) => this.handleInputChangeEvent(e, "name")}
              />
              <FormControl className={classes.input}>
                <ReactSelect
                  listValues={libLocations.availableLocations.map(
                    (al) => al.label
                  )}
                  handleChange={this.handleChange}
                  value={this.state.location}
                  placeholder={i18n.rateLibraries.layerAdd.locationPlaceholder}
                  isMulti
                />
              </FormControl>
              <Input
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: "100",
                }}
                className={classes.input}
                placeholder={i18n.rateLibraries.layerAdd.descriptionPlaceholder}
                onChange={(e) => this.handleInputChangeEvent(e, "description")}
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                disabled={
                  this.state.location.length == 0 || this.state.name.length == 0
                }
                onClick={this.handleNext}
              >
                {i18n.next}
              </Button>
            </div>
            <div
              style={{ height: "calc(100vh - (127px))", overflow: "hidden" }}
            >
              <IconButton
                onClick={this.handleBack}
                className={classes.backLayerIcon}
              >
                <ArrowBack fontSize="small" />
              </IconButton>
              <div style={{ textAlign: "center", width: "100%" }}>
                <div className={classes.layerSecondTitleContainer}>
                  <Typography className={classes.layerTitle} component="h2">
                    {i18n.rateLibraries.layerAdd.title}
                  </Typography>
                </div>
                <div className={classes.layerSecondTitleMessage}>
                  Como você pretende criar este banco?
                </div>
                <div style={{ width: 520, margin: "0 auto" }}>
                  <div
                    style={{
                      width: 230,
                      height: 230,
                      margin: "30px 15px",
                      borderColor: "rgba(0, 0, 0, 0.34)",
                      borderWidth: 1,
                      borderStyle: "solid",
                      float: "left",
                    }}
                  >
                    <div className={classes.soon}>
                      {i18n.rateLibraries.layerAdd.soon}
                    </div>
                    <div className={classes.createBlank}>
                      {i18n.rateLibraries.layerAdd.createBlank}
                    </div>
                  </div>
                  <div className={classes.cardImport}>
                    <input
                      style={{ display: "none" }}
                      accept=".xls, .xlsx"
                      className={classes.input}
                      id="contained-button-file"
                      type="file"
                      onChange={this.fileChangedHandler.bind(this)}
                    />
                    <label
                      htmlFor="contained-button-file"
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: 162,
                          backgroundColor: "rgba(171, 194, 0, 1)",
                        }}
                      >
                        <img
                          style={{ width: 80, position: "relative", top: 35 }}
                          src={imgImport}
                        />
                      </div>
                      <div className={classes.import}>
                        {i18n.rateLibraries.layerAdd.importSpreadsheet}
                      </div>
                    </label>
                    <div style={{ marginTop: "20px", textAlign: "center" }}>
                      <Typography
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {i18n.rateLibraries.layerAdd.fileType}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "#ABC200",
                          textDecoration: "underline",
                        }}
                      >
                        <a
                          style={{ color: "#ABC200" }}
                          target="_blank"
                          href="https://megasistemas.atlassian.net/wiki/spaces/helprubk/pages/496796042/"
                        >
                          {i18n.rateLibraries.layerAdd.spreadsheetTutorial}
                        </a>
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwipeableViews>
        </Grid>
      </CSSTransition>
    );
  }
}

export default withStyles(styles)(LayerAddRateLibrary);



// WEBPACK FOOTER //
// ./src/modules/rateLibrary/components/layouts/LayerAddRateLibrary.tsx